import { View } from './view'

export const OurValues = View
